<script setup>
import {ref} from "vue";

import FirefighterImage from "../../assets/firefighter.png";
import HarmImage from "../../assets/harm.png";
import DisastedImage from "../../assets/disaster.png";
import TsunamiImage from "../../assets/tsunami.png";
import TerrorImage from "../../assets/terror.png";
import CrashImage from "../../assets/crash.png";

import InfoCard from "./info-card.vue";

const data = ref([
    {
        title: "business.product.first.title",
        subtitle: "business.product.first.subtitle",
        image: {
            src: FirefighterImage,
            width: 631,
            height: 361,
            fit: "cover",
            position: "center top"
        }
    },
    {
        title: "business.product.second.title",
        subtitle: "business.product.second.subtitle",
        image: {
            src: HarmImage,
            width: 631,
            height: 421,
            fit: "cover",
            position: "center bottom"
        }
    },
    {
        title: "business.product.third.title",
        subtitle: "business.product.third.subtitle",
        image: {
            src: DisastedImage,
            width: 631,
            height: 421,
            fit: "cover",
            position: "center center"
        }
    },
    {
        title: "business.product.fourth.title",
        subtitle: "business.product.fourth.subtitle",
        image: {
            src: TsunamiImage,
            width: 631,
            height: 475,
            fit: "cover",
            position: "center center"
        }
    },
    {
        title: "business.product.fiveth.title",
        subtitle: "business.product.fiveth.subtitle",
        image: {
            src: TerrorImage,
            width: 631,
            height: 421,
            fit: "cover",
            position: "center center"
        }
    },
    {
        title: "business.product.sixth.title",
        subtitle: "business.product.sixth.subtitle",
        image: {
            src: CrashImage,
            width: 631,
            height: 421,
            fit: "cover",
            position: "center center"
        }
    },
])
</script>

<template>
    <div>
        <h2 class="title">
            <i18n-t keypath="business.product.title">
                <template #product_name>
                    <span class="corp-gradient">“{{ $t("business.hero.title") }}”</span>
                </template>
            </i18n-t>
        </h2>

        <div class="cards">
            <div v-for="(item, index) of data">
                <InfoCard
                    v-bind="item"
                    :index="`0${index + 1}`"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>
.title {
    font-size: 30px;
    max-width: 630px;
    color: #535353;
    text-transform: uppercase;
}

.corp-gradient {
    background: linear-gradient(88.7deg, #FF143F -19.62%, #C600DD 51.14%, #1B27FF 121.98%);
    color: transparent;
    background-clip: text;
}

.cards {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 230px 230px;
    
    gap: 20px;

    margin-top: 50px;
}

@media screen and (max-width: 1280px) {
    .cards {
        grid-template-rows: 230px;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;

        max-width: 100vw;

        overflow-x: scroll;

        padding: 0 20px;

        margin-top: 35px;
    }

    .title {
        padding: 0 20px;
    }
}
</style>